import { render, staticRenderFns } from "./WorkBreakCreateUpdate.vue?vue&type=template&id=142be2af&"
import script from "./WorkBreakCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./WorkBreakCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports